import { useEffect, useState } from 'react';
import { Card, Heading, Stack } from '@etg/wings';
import { Overlay } from '@eti/components';
import { deselectAll, getTotalDisplayPrice, hasSelectionChanged, toggleSegment } from '../utils/segmentSelection';
import { useSegmentDetails } from '../hooks/useSegmentDetails';
import SegmentPassList from './SegmentPassList';
import TotalFooter from './TotalFooter';
import ValidationModal from './ValidationModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const SelectionDrawer = ({
  isOpen,
  initialSegments,
  committedSegments,
  labels,
  isMultiStop,
  config,
  onClose,
  onSave
}) => {
  const [draft, setDraft] = useState(initialSegments);
  const [showValidation, setShowValidation] = useState(false);
  const {
    detailsSegment,
    isDetailsOpen,
    openDetails,
    closeDetails
  } = useSegmentDetails();
  useEffect(() => {
    if (!isOpen) {
      setDraft(initialSegments);
    }
  }, [initialSegments, isOpen]);
  const handleToggle = index => setDraft(prev => toggleSegment(prev, index));
  const handleSave = () => {
    onSave(draft);
    onClose();
  };
  const handleCloseAttempt = () => {
    if (hasSelectionChanged(draft, committedSegments)) {
      setShowValidation(true);
    } else {
      onClose();
    }
  };
  const handleContinueWithout = () => {
    const cleared = deselectAll(draft);
    setDraft(cleared);
    onSave(cleared);
    setShowValidation(false);
    onClose();
  };
  const handleKeepEditing = () => setShowValidation(false);
  const {
    InfoComponent
  } = config;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Overlay.Drawer, {
      dataTestId: `${config.product.name}-drawer`,
      handleClose: handleCloseAttempt,
      isOpen: isOpen,
      shouldOpenHorizontally: true,
      children: [/*#__PURE__*/_jsx(Overlay.Header, {
        onClose: handleCloseAttempt,
        title: labels.drawerTitle
      }), /*#__PURE__*/_jsx(Overlay.Content, {
        "data-testid": `${config.product.name}-drawer-content`,
        children: /*#__PURE__*/_jsx(Card, {
          padding: 16,
          children: /*#__PURE__*/_jsxs(Stack, {
            spacing: 32,
            children: [/*#__PURE__*/_jsx(Heading, {
              level: 3,
              children: labels.drawerCardTitle
            }), /*#__PURE__*/_jsx(SegmentPassList, {
              isMultiStop: isMultiStop,
              labels: labels,
              onSeeDetails: config.hasInfo ? openDetails : undefined,
              onToggle: handleToggle,
              segments: draft
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Overlay.Footer, {
        children: /*#__PURE__*/_jsx(TotalFooter, {
          onSave: handleSave,
          saveLabel: labels.save,
          totalPriceLabel: labels.totalPriceLabel,
          totalPriceRaw: getTotalDisplayPrice(draft)
        })
      })]
    }), /*#__PURE__*/_jsx(ValidationModal, {
      isOpen: showValidation,
      labels: labels,
      onContinueWithout: handleContinueWithout,
      onKeepEditing: handleKeepEditing
    }), config.hasInfo && InfoComponent && /*#__PURE__*/_jsx(InfoComponent, {
      dataTestId: `${config.product.name}-drawer-info-dialog`,
      isOpen: isDetailsOpen,
      onClose: closeDetails,
      segment: detailsSegment
    })]
  });
};
export default SelectionDrawer;
//# sourceMappingURL=SelectionDrawer.js.map